import i18next from "i18next";
import { secureStorage } from "../services/localStorage.service";
import { OrderSideString, equalsIgnoreCase, getOrderTypeViewString } from ".";
import { store } from '../redux/_store/configureStore';
import { saveUserKey } from "../redux/_actions/user.action";
import { AxiosError } from "axios";
import { toast } from "react-toastify";

enum ErrorMessages {
  GeneralErrorMessage = 'error_msg.operation_failed',
  GetError = 'error_msg.get_error',
  Unauthorized = 'error_msg.token_expired',
  NetworkError = 'error_msg.network_error',
}

interface ErrorOptions {
  reqestType?: string, 
  ignoreErrors?: [number], 
  customMsg?: string,
  toastId?: number
}
interface IError {
  data: { message: string };
  status: number;
}

export const isErrNetwork = (err) => err.code === "ERR_NETWORK";

export const isCancelError = (message: string) => (
  message?.toLowerCase().includes("user denied") 
  || message?.toLowerCase().includes("user rejected") 
  || message?.toLowerCase().includes("user has rejected") 
);

export const checkingTradingKeyError = (error, sdkClient) => {
  if ((error.response?.status === 400 && 
    (equalsIgnoreCase(error.response?.data?.message, "Trading key not found") 
    || equalsIgnoreCase(error.response?.data?.message, "Incorrect login address for trading key")))) 
  {
    secureStorage.clearKeyState();
    store.dispatch(saveUserKey(null));
    sdkClient.mainWallet.tradingKey = null;
  }
}

export const getErrorMessage = (message: string, baseCurrency = null, orderSide = null, orderType = null) => {
  if (!message) return "";
  if (isCancelError(message)) {
    return i18next.t("error_msg.aborted_text")
  } else if (message.toLowerCase().includes("transaction")) {
    if (orderSide)
      return i18next.t("obd_notifications.order_creation_failed", 
        {side: OrderSideString[orderSide].toUpperCase(), coin: baseCurrency.toUpperCase(), type: getOrderTypeViewString(orderType) })
    if (message.toLowerCase().includes("below min")) 
      return i18next.t("error_msg.min_algo_balance")
    return message
  } else {
    return message
  }
}

export const errorHandler = (error: AxiosError | IError, options?: ErrorOptions) => {
  if (error instanceof AxiosError) {
    const { request, response } = error;
    const method = error?.config?.method || null;
  
    if (isErrNetwork(error)) {
      console.log("error have ERR_NETWORK code");
      toastReadableError(method, null, ErrorMessages.NetworkError, options);
    } else if (response) {
      const { data, status } = response as IError;
      toastReadableError(method, status, data.message, options);
    } else if (request) {
      console.log("error have request, but no response")
      // Request sent but no response
    } else {
      console.log("error have no response, no request")
      toastReadableError(null, null, error.message, options);
    }
  } else if (error) {
    const message = error.data?.message;

    if (message) {
      toastReadableError(null, null, message, options);
    }
  }

  return isErrNetwork(error);
};

const toastReadableError = (method: string, status: number, errMsg: string, options?: ErrorOptions) => {
  let message = "";

  if (options?.customMsg) {
    message = options?.customMsg
  } else if (method === "get") {
    message = Array.isArray(errMsg) ? errMsg.join(". ") : getErrorMessage(errMsg) || ErrorMessages.GetError;
  } else if (status >= 500 || status === 404) {
    message = ErrorMessages.GeneralErrorMessage;
  } else {
    message = Array.isArray(errMsg) ? errMsg.join(". ") : getErrorMessage(errMsg);
    if (!message) {
      message = ErrorMessages.GeneralErrorMessage;
      if (status === 401) message = ErrorMessages.Unauthorized;
    }
  }

  if (options?.toastId) toast.dismiss(options.toastId);
  toast.error(`${i18next.t(message)}`, {className: "custom-toast"});
}
